// @ts-nocheck
(function () {
  const dock = document.querySelector('[data-dock]');
  if (!dock) return;

  // Prefixo de idioma (mesma lógica do menu): Shopify.routes.root = "/fr/" em FR.
  function currentLocalePrefix() {
    if (window.Weglot && typeof window.Weglot.getCurrentLang === "function") {
      try {
        const l = window.Weglot.getCurrentLang();
        if (l && l.toLowerCase() !== "en") return "/" + l.toLowerCase();
        if (l && l.toLowerCase() === "en") return "";
      } catch (e) {}
    }
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    const rootPrefix = root.replace(/\/+$/, "");
    if (rootPrefix) return rootPrefix;
    const seg = window.location.pathname.split("/").filter(Boolean)[0] || "";
    if (/^[a-z]{2}(-[a-z]{2})?$/i.test(seg) && seg.toLowerCase() !== "en") {
      return "/" + seg.toLowerCase();
    }
    return "";
  }

  function localizedPath(path) {
    if (!path) return path;
    const prefix = currentLocalePrefix();
    if (!prefix) return path;
    let origin = "", p = path, rest = "";
    if (/^https?:\/\//i.test(path)) {
      try {
        const u = new URL(path);
        if (u.hostname !== window.location.hostname) return path;
        origin = u.origin; p = u.pathname; rest = u.search + u.hash;
      } catch (e) { return path; }
    } else if (!path.startsWith("/")) {
      return path;
    }
    if (p === prefix || p.startsWith(prefix + "/")) return path;
    return origin + prefix + p + rest;
  }

  const trigger = dock.querySelector('[data-search-trigger]');
  const panel = dock.querySelector('[data-dock-search-panel]');
  const input = panel?.querySelector('input.dock-search-input');
  const results = panel?.querySelector('.dock-search-results');
  const statusEl = panel?.querySelector('.dock-search-status');
  const closeBtn = panel?.querySelector('.dock-search-close');
  const viewAll = panel?.querySelector('.dock-search-viewall');
  const searchPanel = dock.querySelector('.dock-panel--search');

  const menuPanel = dock.querySelector('[data-dock-panel]');

  function matchNavWidth() {
    const nav = dock.querySelector('.dock__nav');
    if (!nav || !searchPanel || !menuPanel) return;

    let navWidth = '';

    function applyMenuWidth() {
      if (menuPanel.classList.contains('is-bespoke-mode')) {
        menuPanel.style.width = '';
      } else if (menuPanel.classList.contains('is-open')) {
        menuPanel.style.width = navWidth;
      }
    }

    new ResizeObserver(([entry]) => {
      navWidth = entry.contentRect.width + entry.contentRect.x * 2 + 'px';
      searchPanel.style.width = navWidth;
      applyMenuWidth();
    }).observe(nav);

    new MutationObserver(applyMenuWidth).observe(menuPanel, { attributes: true, attributeFilter: ['class'] });
  }
  if (!trigger || !panel || !input || !results || !statusEl || !closeBtn || !viewAll) return;

  matchNavWidth();

  let abortCtrl = null;
  let lastQuery = '';

  function open() {
    // Fecha painel do menu (hover)
    if (menuPanel) {
      menuPanel.classList.remove('is-open');
      menuPanel.setAttribute('aria-hidden', 'true');

      dock.querySelectorAll('[data-dock-item]').forEach(btn => {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    setTimeout(() => input?.focus(), 0);
  }

  function close() {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
  }

  // CLICK ONLY
  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    panel.classList.contains('is-open') ? close() : open();
  });

  closeBtn.addEventListener('click', () => {
    input.value = '';
    closeBtn.classList.remove('is-visible');
    search('');
    close();
  });

  // ESC fecha
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  // Clique fora fecha
  document.addEventListener('click', (e) => {
    if (!panel.classList.contains('is-open')) return;
    if (!panel.contains(e.target) && !trigger.contains(e.target)) close();
  });

  function debounce(fn, delay) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  }

  function escapeHtml(str) {
    return String(str || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function render(products) {
    // preview de produtos removido — search vai direto para a página de resultados
    results.innerHTML = '';
  }

  async function search(q) {
    const query = q.trim();
    searchPanel.classList.remove('has-results');
    lastQuery = query;

    // Sem preview: apenas atualiza o destino do botão/Enter e limpa qualquer status.
    statusEl.textContent = '';
    results.innerHTML = '';
    viewAll.href = query
      ? localizedPath(`/search?q=${encodeURIComponent(query)}`)
      : localizedPath('/search');
  }

  input.addEventListener('input', debounce(() => {
    const val = input.value;
    closeBtn.classList.toggle('is-visible', val.length > 0);
    search(val);
  }, 180));

  // ENTER = ir para a página de resultados (mesmo destino do botão "view all"),
  // já localizado (/fr/search?q=... em francês).
  input.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const q = input.value.trim();
    if (!q) return;
    window.location.href = localizedPath(`/search?q=${encodeURIComponent(q)}`);
  });

  // Botão "Rechercher" (view all) também segue o destino localizado no clique,
  // garantindo consistência mesmo se o href não tiver atualizado ainda.
  viewAll.addEventListener('click', (e) => {
    const q = input.value.trim();
    if (!q) return;
    e.preventDefault();
    window.location.href = localizedPath(`/search?q=${encodeURIComponent(q)}`);
  });
})();